import { FC } from 'react'

interface PinnedIconDesktopProps {
  size?: number
  color?: string
  className?: string
  opacity?: number
}

export const PinnedIconDesktop: FC<PinnedIconDesktopProps> = ({
  size = 20,
  color = 'white',
  className = '',
  opacity = 1,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ opacity }}
    >
      <g>
        <path
          d="M6.24701 7.07812H12.6567"
          stroke={color}
          strokeOpacity="0.8"
          strokeWidth="1.09881"
          strokeLinecap="round"
        />
        <path
          opacity="0.8"
          d="M15.8444 9.2237C16.0129 8.93188 16.386 8.83189 16.6779 9.00038V9.00038C16.9697 9.16886 17.0697 9.54201 16.9012 9.83383L13.3773 15.9374C13.3388 16.0041 13.284 16.06 13.2181 16.1L12.6625 16.4367C12.4772 16.5491 12.2408 16.4126 12.2455 16.196L12.2593 15.5464C12.2609 15.4694 12.282 15.394 12.3205 15.3272L15.8444 9.2237Z"
          fill={color}
        />
        <path
          d="M6.24701 11.1992H11.2832"
          stroke={color}
          strokeOpacity="0.8"
          strokeWidth="1.09881"
          strokeLinecap="round"
        />
        <path
          d="M15.4037 6.36299V4.33134C15.4037 3.31992 14.5838 2.5 13.5724 2.5H5.33135C4.31992 2.5 3.5 3.31992 3.5 4.33135V14.4037C3.5 15.4152 4.31992 16.2351 5.33134 16.2351H9.45187"
          stroke={color}
          strokeOpacity="0.8"
          strokeWidth="1.09881"
          strokeLinecap="round"
        />
      </g>
    </svg>
  )
}
